import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog } from 'omni-common-ui';
import styles from './style.postcss';

const DEFAULT_TITLE = 'Progress Report generation failed';
const DEFAULT_MESSAGE =
  "The system won't be able to generate a Progress Report until a Unit Quiz result has been recorded in this group.";

const ProgressReportGenerationFailedDialog = ({
  isOpen,
  title = DEFAULT_TITLE,
  message = DEFAULT_MESSAGE,
  confirmButtonText = 'Got it',
  onConfirmClick,
}) => (
  <Dialog
    isOpen={isOpen}
    className={styles.ProgressReportGenerationFailedDialog_card}
    onRequestClose={() => onConfirmClick()}
  >
    <div className={styles.ProgressReportGenerationFailedDialog}>
      <div className={styles.ProgressReportGenerationFailedDialog_content}>
        <div className={styles.ProgressReportGenerationFailedDialog_header}>
          <span
            className={styles.ProgressReportGenerationFailedDialog_icon}
            aria-hidden="true"
          >
            <svg viewBox="0 0 30 27" xmlns="http://www.w3.org/2000/svg">
              <path
                className={styles.ProgressReportGenerationFailedDialog_iconTriangle}
                d="M29.2665,25.47 L15.906,0.522 C15.72,0.1995 15.375,0 15,0 C14.6235,0 14.2785,0.1995 14.094,0.522 L0.735,25.47 C0.5535,25.7865 0.5565,26.1765 0.7425,26.49 C0.93,26.8065 1.2705,27 1.6395,27 L28.3605,27 C28.7295,27 29.07,26.8065 29.2575,26.49 C29.4435,26.1765 29.4465,25.7865 29.2665,25.47 Z"
              />
              <path
                className={styles.ProgressReportGenerationFailedDialog_iconExclamation}
                d="M16.5,18.75 L13.5,18.75 L13.5,9 L16.5,9 L16.5,18.75 Z M16.5,24 L13.5,24 L13.5,21 L16.5,21 L16.5,24 Z"
              />
            </svg>
          </span>
          <span className={styles.ProgressReportGenerationFailedDialog_title}>
            {title}
          </span>
        </div>
        <p className={styles.ProgressReportGenerationFailedDialog_message}>
          {message}
        </p>
      </div>
      <Button.Container
        align="center"
        className={styles.ProgressReportGenerationFailedDialog_buttonWrapper}
      >
        <Button
          type={Button.Type.primary}
          className={styles.ProgressReportGenerationFailedDialog_button}
          onClick={() => onConfirmClick()}
        >
          {confirmButtonText}
        </Button>
      </Button.Container>
    </div>
  </Dialog>
);

ProgressReportGenerationFailedDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
  confirmButtonText: PropTypes.string,
  onConfirmClick: PropTypes.func.isRequired,
};

export default ProgressReportGenerationFailedDialog;



// WEBPACK FOOTER //
// ./containers/Group/ProgressReportHFv4/IndividualDevelopmentPlanListView/ProgressReportGenerationFailedDialog/index.jsx